import {html, css, LitElement, live} from 'lit';


export class DzQuantityInput extends LitElement {
    static styles = css`
        :host {
            display: inline-flex;
        }

        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
            width: auto;
        }
        input[type="number"] {
            -moz-appearance: textfield;
        } 
    `;

    static properties = {
        min:   {type: Number},
        max:   {type: Number},
        step:  {type: Number},
        value: {type: Number, reflect: true}
    };

    constructor() {
        super();
        this.min   = 1
        this.max   = 99
        this.step  = 1
        this.value = 1    
    }

    render() {
        return html`
            <slot name="minus" @click="${this.decrement}"></slot>
            <input type="number" .value=${live(this.value.toString())} @change=${this.change} part="input" pattern="\d*" step="${this.step}">
            <slot name="plus" @click="${this.increment}"></slot>
        `
    }

    clip(value) {
        return Math.min(this.max, Math.max(this.min, Math.round(Math.abs(value))))
    }

    change(evt) {
        this.value = this.clip(evt.target.value)
        this.requestUpdate()
    }

    increment() {
        this.value = this.clip(this.value + this.step)
    }

    decrement() {
        this.value = this.clip(this.value - this.step)
    }
}

customElements.define('dz-quantity-input', DzQuantityInput);